// import React, { useEffect, useState } from "react";
// import classes from "./EditBrandModal.module.css";
// import API from "../../utils/api";
// import RenderToast from "../../components/RenderToast";

// const slugify = (value) =>
//   value
//     .toLowerCase()
//     .trim()
//     .replace(/[^a-z0-9\s-]/g, "")
//     .replace(/\s+/g, "-")
//     .replace(/-+/g, "-");

// export default function EditBrandModal({ brand, onClose, onSuccess }) {
//   const [form, setForm] = useState({ name: "", slug: "" });
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     if (brand) {
//       setForm({
//         name: brand.brandName,
//         slug: brand.brand_slug || slugify(brand.brandName),
//       });
//     }
//   }, [brand]);

//   if (!brand) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm((prev) => ({ ...prev, [name]: value }));
//     if (name === "name") {
//       setForm((prev) => ({ ...prev, slug: slugify(value) }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.name.trim()) {
//       return RenderToast({ type: "error", message: "Brand name is required" });
//     }
//     setSaving(true);
//     try {
//       const token = localStorage.getItem("authToken") || "";
//       const params = new URLSearchParams();
//       params.append("action", "update");
//       params.append("id", brand.id);
//       params.append("brand_name", form.name.trim());
//       params.append("brand_slug", form.slug);

//       const response = await fetch(`${API.base}/brands.php`, {
//         method: "POST",
//         headers: {
//           Authorization: token,
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: params,
//       });
//       const data = await response.json();
//       if (!response.ok || !data.success) {
//         throw new Error(data.error || "Failed to update brand");
//       }
//       RenderToast({ type: "success", message: "Brand updated successfully" });
//       onSuccess?.();
//       onClose();
//     } catch (err) {
//       RenderToast({ type: "error", message: err.message });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className={classes.backdrop} onClick={onClose}>
//       <div
//         className={classes.modal}
//         onClick={(e) => {
//           e.stopPropagation();
//         }}
//       >
//         <header className={classes.header}>
//           <h3>Edit Brand</h3>
//           <button className={classes.closeBtn} onClick={onClose}>
//             ×
//           </button>
//         </header>
//         <form className={classes.form} onSubmit={handleSubmit}>
//           <label>
//             <span>Brand Name</span>
//             <input
//               type="text"
//               name="name"
//               value={form.name}
//               onChange={handleChange}
//               placeholder="e.g. Nvidia"
//             />
//           </label>
//           <label>
//             <span>Slug</span>
//             <input type="text" name="slug" value={form.slug} disabled />
//           </label>
//           <div className={classes.actions}>
//             <button
//               type="button"
//               className={classes.secondaryBtn}
//               onClick={onClose}
//               disabled={saving}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className={classes.primaryBtn}
//               disabled={saving}
//             >
//               {saving ? "Saving..." : "Update Brand"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import classes from "./EditBrandModal.module.css";
import API from "../../utils/api";
import RenderToast from "../../components/RenderToast";

const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export default function EditBrandModal({ brand, onClose, onSuccess }) {
  const [form, setForm] = useState({ name: "", slug: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (brand) {
      setForm({
        name: brand.brandName,
        slug: brand.brand_slug || slugify(brand.brandName),
      });
    }
  }, [brand]);

  if (!brand) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "name") {
      setForm((prev) => ({ ...prev, slug: slugify(value) }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      return RenderToast({ type: "error", message: "Brand name is required" });
    }
    if (!form.slug.trim()) {
      return RenderToast({ type: "error", message: "Slug cannot be empty" });
    }

    setSaving(true);
    try {
      const token = localStorage.getItem("authToken") || "";
      const params = new URLSearchParams();
      params.append("action", "update");
      params.append("id", brand.id);
      params.append("brand_name", form.name.trim());
      params.append("brand_slug", form.slug.trim());

      const response = await fetch(`${API.base}/brands.php`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.error || "Failed to update brand");
      }

      RenderToast({ type: "success", message: "Brand updated successfully" });
      onSuccess?.();
      onClose();
    } catch (err) {
      RenderToast({ type: "error", message: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
        <header className={classes.header}>
          <h3>Edit Brand</h3>
          <button className={classes.closeBtn} onClick={onClose}>
            ×
          </button>
        </header>

        <form className={classes.form} onSubmit={handleSubmit}>
          <div className={classes.scrollable}>
            <label>
              <span>Brand Name</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="e.g. Nvidia"
                disabled={saving}
              />
            </label>

            <label>
              <span>Slug</span>
              <input
                type="text"
                name="slug"
                value={form.slug}
                onChange={handleChange}
                placeholder="e.g. nvidia"
                disabled={saving}
              />
            </label>
          </div>

          <div className={classes.actions}>
            <button
              type="button"
              className={classes.secondaryBtn}
              onClick={onClose}
              disabled={saving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={classes.primaryBtn}
              disabled={saving}
            >
              {saving ? "Saving..." : "Update Brand"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
